import React from "react";
import { Stack, Typography } from "@mui/material";

import WorkOrderLabel from "./WorkOrderLabel";
import { NotesStack, StyledBaseBox, StyledFinishStack } from "./styles";
import { Checkbox } from "../../svgs";
import { useStationListWithCache } from "../../components/StationHookFormSelect";
import { getWorkOrderInstructions } from "./helper";

const getGrind = (flush) =>
  flush === 1 ? "Flush" : flush === 2 ? "Witness" : "";

const getStation = (stations = [], id, grindType) => {
  const station = stations?.find((m) => m.id === id);
  const label = station?.label;

  if (!grindType || !label?.includes("Grind")) {
    return label;
  }
  return `${label} (${grindType})`;
};

const WorkOrderFinish = ({ data }) => {
  const { stations = [] } = useStationListWithCache();

  let post = getWorkOrderInstructions(data, 5);
  let config = post?.config;
  let grindType = getGrind(config?.flushWitness);

  // Append grind type to station label if applicable
  let routes = post?.routing?.map(({ stationId, notes, config }) => ({
    isOutside: config?.isOutside,
    notes: notes,
    station: getStation(stations, stationId, grindType),
  }));

  return (
    <StyledBaseBox columns={3} disableBorder={true}>
      <NotesStack col="3">
        <Typography variant="caption" fontWeight={400} lineHeight="14px">
          INST: <strong>{post?.notes}</strong>
        </Typography>
      </NotesStack>
      <StyledFinishStack>
        <Typography variant="boldCaptionMain">Finish Department</Typography>
        {routes?.map((r, i) => (
          <Stack direction="row" gap="5px" alignItems="center">
            <Checkbox color="#C0C0C0" size={14} />
            <WorkOrderLabel
              label={`${i + 1}. ${r?.station}`}
              value={r?.notes}
              valueBold
              {...(r.isOutside
                ? { backgroundColor: "hubColors.mainFocusLighter" }
                : {})}
            />
          </Stack>
        ))}
      </StyledFinishStack>
    </StyledBaseBox>
  );
};

export default WorkOrderFinish;
